import RewardsCouponSection from './RewardsCouponSection';

export default function RewardsRedeemTab() {
  return (
    <>
      <RewardsCouponSection />
    </>
  );
}
